import { render } from "./navigation.vue?vue&type=template&id=351ca424&scoped=true&ts=true"
import script from "./navigation.vue?vue&type=script&lang=ts"
export * from "./navigation.vue?vue&type=script&lang=ts"

import "./navigation.vue?vue&type=style&index=0&id=351ca424&lang=less&scoped=true"

import exportComponent from "/workspace/source-code/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-351ca424"]])

export default __exports__